import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect, useState} from 'react'
import {useLogger} from '../../../hooks/logger'
import {Interaction} from '../../../services/logger'
import {FormButton} from '../../form-button/form-button'
import {ExpressCheckout} from './express-checkout/express-checkout'
import {PaymentProps} from './interfaces'
import {PaymentWidget} from './payment-widget'
import s from './payment.scss'
import {classes} from './paymentsStyleApi.st.css'

const PAYMENT_METHODS_WITHOUT_FEE = ['offline']

export const Payment = ({
  paymentRef,
  editing,
  eventId,
  order,
  reservationId,
  onSubmit,
  openCantCompletePaymentModal,
  t,
  locale,
  isSite,
  isPreview,
  visitorId,
  msid,
  instanceId,
  siteOwnerId,
  navigateToOrder,
  primaryLanguage,
  instance,
  siteStyles,
  isSignedInUser,
  lang,
  updateLayout,
  navigateTo,
  expressCheckout,
  updatePaymentMethod,
  updateOrderInProgress,
}: PaymentProps) => {
  const logger = useLogger()
  const {experiments} = useExperiments()
  const {isMobile} = useEnvironment()
  const [currentPaymentMethodId, setCurrentPaymentMethodId] = useState('')
  const expressCheckoutEnabled = experiments.enabled(ExperimentNames.ExpressCheckout)
  const updatePaymentMethodEnabled = experiments.enabled(ExperimentNames.UpdatePaymentMethodEnabled)
  const paymentsStyleApiEnabled = experiments.enabled(ExperimentNames.PaymentsStyleApi)
  const fixOrderSuccessRoutesEnabled = experiments.enabled(ExperimentNames.FixOrderSuccessRoutes)

  const selectedPaymentMethodWithoutFee =
    updatePaymentMethodEnabled && PAYMENT_METHODS_WITHOUT_FEE.includes(currentPaymentMethodId)

  const expressCheckoutVisible = expressCheckoutEnabled && !selectedPaymentMethodWithoutFee

  const onPaymentMethodChanged = (paymentMethodId: string) => {
    setCurrentPaymentMethodId(paymentMethodId)

    if (updatePaymentMethodEnabled && !isPreview) {
      updatePaymentMethod({paymentMethod: paymentMethodId})
    }
  }

  useEffect(() => {
    logger.startInteraction(Interaction.PaymentWidgetLoad)
  }, [])

  return (
    <div className={classNames(s.container, {[classes.paymentsStyleApi]: paymentsStyleApiEnabled})}>
      <>
        {expressCheckoutVisible ? (
          <ExpressCheckout
            locale={locale}
            msid={msid}
            visitorId={visitorId}
            instanceId={instanceId}
            siteOwnerId={siteOwnerId}
            instance={instance}
            expressCheckout={expressCheckout}
          />
        ) : null}
        <PaymentWidget
          locale={locale}
          ref={paymentRef}
          eventId={eventId}
          snapshotId={order?.snapshotId}
          reservationId={reservationId}
          isMobile={isMobile}
          isPreview={isPreview}
          openCantCompletePaymentModal={openCantCompletePaymentModal}
          navigateToOrder={navigateToOrder}
          navigateTo={navigateTo}
          isSite={isSite}
          visitorId={visitorId}
          msid={msid}
          instanceId={instanceId}
          primaryLanguage={primaryLanguage}
          siteOwnerId={siteOwnerId}
          externalSubmitButton
          order={order}
          lang={lang}
          instance={instance}
          siteStyles={siteStyles}
          isSignedInUser={isSignedInUser}
          updateLayout={updateLayout}
          logger={logger}
          onPaymentMethodChanged={onPaymentMethodChanged}
          currentPaymentMethodId={currentPaymentMethodId}
          fixOrderSuccessRoutesEnabled={fixOrderSuccessRoutesEnabled}
        />
      </>
      {editing && (
        <div className={s.button}>
          <FormButton
            disabled={updatePaymentMethodEnabled && updateOrderInProgress}
            dataHook={DH.PAYMENT_METHOD_SUBMIT}
            type="submit"
            text={t('mobile.checkout.placeOrder')}
            onClick={() => onSubmit()}
          />
        </div>
      )}
    </div>
  )
}
